module.exports = __webpack_public_path__ + "static/media/ChestRed.02c28958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/ChestRed.png
// module id = 2750
// module chunks = 0